










import { DiscordUserInterface } from "@/types";
import { Component, PropSync, Vue } from "vue-property-decorator";
import UserAvatar from "./UserAvatar.vue";

@Component({ components: { UserAvatar } })
export default class UserChip extends Vue {
  @PropSync("user")
  public readonly userProp!: DiscordUserInterface;
}
